/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CriteriaResultCellSchemaMatch = typeof CriteriaResultCellSchemaMatch[keyof typeof CriteriaResultCellSchemaMatch] | null;


export const CriteriaResultCellSchemaMatch = {
  good: 'good',
  partial: 'partial',
  bad: 'bad',
  unknown: 'unknown',
} as const;
